package scenes.test

import assets.*
import b2d.*
import com.github.quillraven.fleks.*
import com.soywiz.korge.box2d.*
import com.soywiz.korge.scene.*
import com.soywiz.korge.view.*
import com.soywiz.korge.view.Camera
import com.soywiz.korge.view.camera.*
import com.soywiz.korim.bitmap.*
import com.soywiz.korim.color.*
import component.*
import input.*
import system.*
import system.single.*
import utils.*
import kotlin.collections.set

const val SCENE_CONTAINER = "sceneContainer"

class SinglePlayerScene : Scene() {

    private val animations = mutableMapOf<String, SpriteAnimation>()
    private val textures = mutableMapOf<String, Bitmap>()

    //    private val physicWorld = World().also {
//        it.customScale = 20.0
//    }
    private lateinit var physicWorldComponent: Box2dWorldComponent

    override suspend fun SContainer.sceneInit() {
        println("SinglePlayerScene sceneInit")

        // load assets
        physicWorldComponent = getOrCreateBox2dWorld().apply {
            world.customScale = GameDimensions.PPM.toDouble()
        }

        loadPlayerAnimation("characters/ninja_frog").forEach {
            animations["ninja-frog-${it.key.name}"] = it.value
        }
    }

    override suspend fun SContainer.sceneMain() {
        println("SinglePlayerScene sceneMain")
        val camera = Camera()
        val cameraContainer = cameraContainer(width, height, clip) {
            camera.addTo(this)
        }

//        val worldMetaData = WorldObjectFactory.loadLevel(physicWorldComponent.world, camera)

        val keyboardControllerView = solidRect(1, 1, Colors.TRANSPARENT_BLACK)
        val keyboardController = KeyboardController(keyboardControllerView)
        keyboardControllerView.addComponent(keyboardController)

        val world = world {
            injectables {
                add(SCENE_CONTAINER, this@sceneMain)
                add(physicWorldComponent.world)
                add(cameraContainer)
                add(camera)
                add(keyboardController)
            }

            components {
                onAdd(PhysicComponent, PhysicComponent.onAddPhysic)
                onRemove(PhysicComponent, PhysicComponent.onRemovePhysic)
            }

            systems {
                add(PlayerSpawnSystem().apply { respawnPlayer = true })
                add(PlayerControlSystem())
                add(Box2dStepSystem())
                add(PhysicDebugSystem())
                add(PlayerAnimationSystem())
                add(SpriteAnimationSystem(animations))
            }
        }

        addUpdater { dt ->
            world.update(dt.seconds.toFloat())
        }
    }
}
